<template>
    <prep-adherence :nextDisabled="nextDisabled">
        <p>
            Nice work! You can see the links to the resources we just covered on the Resources screen.
        </p>
        <div v-if="showReminderReminder">
            <p>
                You said you could use a reminder to help you remember to take PrEP daily. Did you really set a reminder? Setting a reminder can help you remember to take your meds!
            </p>
            <v-radio-group v-model="prepReminderSelection" column>
                <v-radio v-for="reminder in prepReminders" :key="reminder.id" :label="reminder.text" :value="reminder"></v-radio>
            </v-radio-group>
        </div>
    </prep-adherence>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { filter, find, forEach } from 'lodash';

    export default {
        data: function () {
            return {
                prepReminderSelection: null
            };
        },
        computed: {
            prepReminder() {
                let selectedPrepReminder = find(this.prepReminders, 'selected');

                if (selectedPrepReminder) {
                    return selectedPrepReminder;
                } else return null;
            },
            showReminderReminder() {
                let reminderStrategies = filter(filter(this.$store.get('prepRegularStrategiesRevisited'), 'selected'), 'reminderStrategy');

                if (reminderStrategies.length > 0) {
                    return true;
                }

                return false;
            },
            prepReminders: sync('prepReminder')
        },
        methods: {
            nextDisabled() {
                return this.showReminderReminder && !this.prepReminderSelection;
            }
        },
        watch: {
            prepReminderSelection(newPrepReminderSelection) {
                forEach(this.prepReminders, (o) => {
                    if (o.id === newPrepReminderSelection.id) {
                        o.selected = true;
                    } else {
                        o.selected = false;
                    }
                });
            }
        },
        mounted() {
            this.prepReminderSelection = this.prepReminder;
        }
    };
</script>
